import { useTranslation } from 'react-i18next';

import { useRouteDocumentTitle } from '@client/toolkit';

import { PortfolioPaths } from '../../../../portfolio.router';
import { AgreementImportWizard } from './agreement-import-wizard';

export function AgreementImportWizardRoute() {
  const { t } = useTranslation('agreements');
  useRouteDocumentTitle(t('agreementImport.session.title'), PortfolioPaths.BuildingAgreementsImport);

  return <AgreementImportWizard />;
}
